// Version management utility
// This file handles automatic version incrementing

// Base version - this will be updated automatically
const BASE_VERSION = "2.0.2";

const formatVersion = (version) => {
  if (typeof version !== 'string') {
    return BASE_VERSION;
  }
  return version;
};

// Get current version from package.json or use base version
const getCurrentVersion = () => {
  try {
    // Try to get version from package.json
    const packageJson = require('../../package.json');
    return formatVersion(packageJson.version || BASE_VERSION);
  } catch (error) {
    // Fallback to base version
    return formatVersion(BASE_VERSION);
  }
};

// Get git commit hash for build info
const getCommitHash = () => {
  try {
    // In production builds, this will be replaced by webpack
    // For development, try to get from environment or use 'dev'
    if (process.env.REACT_APP_GIT_COMMIT_HASH) {
      return process.env.REACT_APP_GIT_COMMIT_HASH;
    }
    
    // In development, just use 'dev' - child_process doesn't work in browser
    return 'dev';
  } catch (error) {
    return 'dev';
  }
};

// Format version string with commit hash
export const getVersionString = () => {
  const version = getCurrentVersion();
  const commitHash = getCommitHash();
  return `${version} (${commitHash})`;
};

// Export individual components
export const getVersion = getCurrentVersion;
export const getCommit = getCommitHash;
